/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_ReqInputs */

const en_cp_lead_req = /** @type {(inputs: Cp_Lead_ReqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requirements: active student with ≥ 1 year left, 1 PRD + 3 verified tasks completed in Bystep.`)
};

const id_cp_lead_req = /** @type {(inputs: Cp_Lead_ReqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syarat: mahasiswa aktif dengan sisa studi ≥ 1 tahun, sudah menyelesaikan 1 PRD + 3 task terverifikasi di Bystep.`)
};

/**
* | output |
* | --- |
* | "Requirements: active student with ≥ 1 year left, 1 PRD + 3 verified tasks completed in Bystep." |
*
* @param {Cp_Lead_ReqInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_req = /** @type {((inputs?: Cp_Lead_ReqInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_ReqInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_req(inputs)
	return en_cp_lead_req(inputs)
});